import React from 'react';
import { Divider, Flex, Typography } from '@banhala/ui-kit';
import { useGoodsSellerInfo } from '../queries/useGoodsSellerInfo';
import { isNil } from 'shared/src/utils';

const SELLER_INFO_ITEMS = [
  { key: 'business_name', label: '상호' },
  { key: 'business_representative', label: '대표자' },
  { key: 'business_address', label: '주소' },
  { key: 'business_registration_number', label: '사업자등록번호' },
  { key: 'mail_order_business_report_number', label: '통신판매업신고번호' },
  { key: 'email', label: '이메일' },
  { key: 'phone_number', label: '전화번호' },
] as const;

export const SellerInfo: React.FC = () => {
  const { data: sellerInfo } = useGoodsSellerInfo();

  if (isNil(sellerInfo)) return null;

  return (
    <Flex>
      <Divider size="small" />
      <Flex padding={{ horizontal: 16 }}>
        <Flex padding={{ vertical: 20 }}>
          <Typography type={'h5'} color={'content_primary'}>
            판매자 정보
          </Typography>
        </Flex>
        {SELLER_INFO_ITEMS.map(({ key, label }) => (
          <Flex.Row
            key={key}
            alignItems={'flex-start'}
            padding={{ vertical: 12 }}
          >
            <Flex width={120}>
              <Typography type={'body4'} color={'content_secondary'}>
                {label}
              </Typography>
            </Flex>
            <Flex flex={3} margin={{ left: 4 }}>
              <Typography type={'body4'} color={'content_primary'}>
                {sellerInfo[key] || '미입력'}
              </Typography>
            </Flex>
          </Flex.Row>
        ))}
      </Flex>
    </Flex>
  );
};
